module.exports = __webpack_public_path__ + "img/front_water.b30f6207.png";